import AclName from '../AclName';

export default [
  AclName.CrmPageMyAgreementsList,
  AclName.ProfileEditCompanyDataTabAccess,
  AclName.ProfileViewCompanyDataCardAccess,
  AclName.FinancialSummaryView,

  // Edycja profilu
  AclName.CanViewKsefSettings,
  AclName.CanEditKsefSettings,
  AclName.CanViewKsefPurchaseInvoicesList,
  AclName.StaffPageAccidentInsurancesList,
];
